import React from "react";
import BaseComponent from "../../base-component";

class Notifications extends BaseComponent {

    render() {
        return (
            <div>
                {
                    (this.props.notifications || []).map((notification, index) => (
                        <div key={index} className={`alert alert-${notification.type}`}>{ notification.text }</div>
                    ))
                }
            </div>

        );
    }

}

export default Notifications;
